import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { type CalendarEvent } from '@/components/ui/full-calendar'

interface CalendarEventsState {
  events: CalendarEvent[]
  isLoading: boolean
  error: string | null
}

const initialState: CalendarEventsState = {
  events: [],
  isLoading: false,
  error: null
}

const calendarEventsSlice = createSlice({
  name: 'calendarEvents',
  initialState,
  reducers: {
    setEvents: (state, action: PayloadAction<CalendarEvent[]>) => {
      state.events = action.payload
    },
    updateEvent: (
      state,
      action: PayloadAction<{
        eventId: string
        updates: Partial<CalendarEvent>
      }>
    ) => {
      const { eventId, updates } = action.payload
      const eventIndex = state.events.findIndex((event) => event.id === eventId)
      if (eventIndex !== -1) {
        state.events[eventIndex] = { ...state.events[eventIndex], ...updates }
      }
    },
    revertEvent: (
      state,
      action: PayloadAction<{ eventId: string; originalEvent: CalendarEvent }>
    ) => {
      const { eventId, originalEvent } = action.payload
      const eventIndex = state.events.findIndex((event) => event.id === eventId)
      if (eventIndex !== -1) {
        state.events[eventIndex] = originalEvent
      }
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    }
  }
})

export const { setEvents, updateEvent, revertEvent, setLoading, setError } =
  calendarEventsSlice.actions
export default calendarEventsSlice.reducer
